/* MamaMilla header rebuild v3 – companion JS
   Clones the search form into the header top row on desktop and keeps it
   positioned. Width is computed around the CENTER so the bar can never
   overlap the logo (left) or the icons (right), also in sticky mode. */
(function () {
  'use strict';

  function init() {
    var source = document.querySelector('.mm-search-bar-section form.mm-search-bar');
    var header = document.querySelector('header.header');
    if (!header || !source || header.querySelector('.mm-search-bar--in-header')) return;

    var inHeader = source.cloneNode(true);
    inHeader.classList.add('mm-search-bar--in-header');
    header.appendChild(inHeader);

    var position = function () {
      if (window.innerWidth < 990) return;
      var logoLink = header.querySelector('.header__heading-link');
      var icons = header.querySelector('.header__icons');
      var headerRect = header.getBoundingClientRect();
      if (logoLink) {
        var lr = logoLink.getBoundingClientRect();
        inHeader.style.top =
          Math.max(0, lr.top - headerRect.top + lr.height / 2 - inHeader.offsetHeight / 2) + 'px';
      } else {
        inHeader.style.top = '1.2rem';
      }
      if (logoLink && icons) {
        var center = headerRect.left + headerRect.width / 2;
        var leftRoom = center - logoLink.getBoundingClientRect().right - 24;
        var rightRoom = icons.getBoundingClientRect().left - center - 24;
        var width = 2 * Math.min(leftRoom, rightRoom);
        width = Math.max(200, Math.min(640, width));
        inHeader.style.setProperty('--mm-search-width', width + 'px');
      }
    };

    position();
    window.addEventListener('resize', position);
    if (window.ResizeObserver) new ResizeObserver(position).observe(header);
    // Reposition when the sticky state class changes on the section wrapper
    var sectionWrapper = header.closest('.shopify-section-header') || header.parentElement;
    if (window.MutationObserver && sectionWrapper) {
      new MutationObserver(position).observe(sectionWrapper, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
